var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ListEstaComercial"},[_c('HeaderPage'),_c('el-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingPage),expression:"loadingPage"}]},[_c('FilterBox',{attrs:{"currentPage":_vm.listData.meta ? _vm.listData.meta.pagination.current_page : 1},on:{"filter":_vm.listDados,"filterExport":_vm.exportDados}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }